import { Directive, ElementRef, HostListener, Output, EventEmitter } from '@angular/core';

@Directive({
  selector: '[vsOverlay]'
})
export class OutsideClickDirective {
  @Output() appOutsideClick = new EventEmitter();


  constructor(private _elementRef: ElementRef) {
  }

  @HostListener('document:click', ['$event.target'])
  public onClick(targetElement) {

    let btn = this._elementRef.nativeElement.firstChild;
    let popup = this._elementRef.nativeElement.lastChild;

    const clickedInside = this._elementRef.nativeElement.contains(targetElement);
    if (clickedInside) {
      // Click vào popup hoặc btn nhưng đã active popup hoặc Nếu click vào 1 item có class selected để đóng popup
      if ((!popup.contains(targetElement) && popup.className == "vs-overlay-popup active") || targetElement.classList.contains("selected")) {
        popup.classList.remove("active");
        btn.classList.remove("active");
        this.appOutsideClick.emit(true);
      }
      else {
        popup.classList.add("active");
        popup.style.top = btn.clientHeight + "px";
        btn.classList.add("active");
        this.appOutsideClick.emit(false);

        let inputTask = document.getElementById("txtLabelsearch");
        if (inputTask) inputTask.focus();

      }
    } else {
      try {
        if (!targetElement.className.includes("ui-dropdown-item") && !targetElement.offsetParent.className.includes("ui-dropdown-panel")) {
          popup.classList.remove("active");
          btn.classList.remove("active");
          this.appOutsideClick.emit(true);
        }
      } catch (ex) { }
    }
  }
  // @HostListener('click')
  // clickInside($event) {
  //   console.log("sss");
  //   //this.text = "clicked inside";
  //   //$event.stopPropagation();
  // }

}